<template>
  <!-- モーダルウィンドウ -->
  <div
    class="c-modal"
    :class="[classes ? classes : '', {'is-active': isActive}]"
  >
    <div class="c-modal__bg" @click="onCloseClick"></div>
    <div class="c-modal__content c-modal__content--full-width">
      <div class="c-modal__close" @click="onCloseClick">
        <div class="c-icon c-icon--white u-wh14">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <use xlink:href="/assets/img/sprite.svg#close" />
          </svg>
        </div>
      </div>
      <div class="c-modal__inner">
        <div class="c-calendar">
          <div class="c-calendar__content">
            <div class="c-calendar__datepicker">
              <v-date-picker
                v-model.range="params"
                :columns='3'
                :masks="masks"
                :max-date="range.end"
                :min-date="range.start"
                locale="ja"
              />
            </div>
          </div>
          <div class="c-calendar__foot">
            <div class="c-calendar__btns">
              <button
                v-if="cancelButtonLabel && onCancelClick"
                :class="[`c-btn c-btn--modal c-btn--gray u-w280 u-h34 u-fs14`]"
                type="button"
                name="cancel"
                value="cancel"
                @click="onCancelClick"
              >
                <p class="c-btn__text">{{ cancelButtonLabel }}</p>
              </button>
              <button
                v-if="enterButtonLabel && onEnterClick"
                :class="[`c-btn c-btn--modal c-btn--blue u-w280 u-h34 u-fs14`, {'is-loading': isLoading}]"
                type="button"
                name="delete"
                value="delete"
                :disabled="isLoading"
                @click="() => onEnterClick(params.start, params.end)"
              >
                <p class="c-btn__text">{{ enterButtonLabel }}</p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
<!-- /モーダルウィンドウ -->
</template>

<script>
import { DatePicker } from 'v-calendar';
import 'v-calendar/style.css';

export default {
  components: { 'v-date-picker': DatePicker },
  props: {
    body: { type: String, required: false },
    cancelButtonLabel: { type: String, required: false },
    classes: { type: String, required: false },
    dates: { type: Object, required: true },
    enterButtonLabel: { type: String, required: false },
    isActive: { type: Boolean, required: true },
    isBodyHtml: { type: Boolean, required: false },
    onCancelClick: { type: Function, required: false },
    onCloseClick: { type: Function, required: true },
    onEnterClick: { type: Function, required: false },
    title: { type: String, required: false },
  },
  data() {
    return {
      errorMessage: '',
      isLoading: false,
      params: {
        start: this.dates.from,
        end: this.dates.to,
      },
      masks: {
        title: 'YYYY年 M月',
        navMonths: 'M月',
      },
      range: {
        start: (this.dates.maxDate) ? this.dates.minDate : this.dates.from,
        end: (this.dates.minDate) ? this.dates.maxDate : this.dates.to,
      }
    }
  },
  computed: {
  },
  methods: {
    showLoader() {
      this.isLoading = true;
    },
    hideLoader() {
      // 早すぎて変な表示になる事があるので、1拍おいてから非表示化
      setTimeout(() => {
        this.isLoading = false;
      }, 300)
    },
    toggleLoader() {
      this.isLoading = !this.isLoading;
    },
    showErrorMessage(message) {
      this.errorMessage = message;
    },
    resetErrorMessage() {
      this.errorMessage = '';
    },
    resetParams(params) {
      const data = {
        start: params.from,
        end: params.to,
      }
      // オブジェクトアサインで参照要素に伝搬 (* キー値を変更するだけでは値変更を検知できないため
      this.params = Object.assign({}, data);
    },
  }
};
</script>
